import { render, staticRenderFns } from "./AdminOrganization.vue?vue&type=template&id=2ebfaade&scoped=true&"
import script from "./AdminOrganization.vue?vue&type=script&lang=js&"
export * from "./AdminOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrganization.vue?vue&type=style&index=0&id=2ebfaade&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfaade",
  null
  
)

export default component.exports